export const GET_SCHEDULE_REPORTS_DATA="GET_SCHEDULE_REPORTS_DATA"
export const GET_MIS_DOWNLOAD_DATA="GET_MIS_DOWNLOAD_DATA"
export const ACTIVIES_LOG_DATA="ACTIVIES_LOG_DATA"
export const GET_REPORTS_ORDERS_DATA="GET_REPORTS_ORDERS_DATA"
export const GET_REPORTS_SHIPMENTS_DATA="GET_REPORTS_SHIPMENTS_DATA"
export const GET_REPORTS_RETURNS_DATA="GET_REPORTS_RETURNS_DATA"
export const GET_REPORTS_BILLING_DATA="GET_REPORTS_BILLING_DATA"